<template lang="pug">
#read.scrollIntoView
  EcreativMoleculesTitleSection.mb-5(
    title="Read"
    subTitle="Dive into Islamic Wisdom and Knowledge"
  )
  EcreativMoleculesTabsAndSidebar(@tab-click="setSelected")
    template(#tab-articles)
      .articles-grid
        EcreativMoleculesCardsCard7.item(
          v-for='item in articles'
          :id='item.id',
          :key='item.id',
          :image='item.image',
          :title='item.title',
          :content="''",
          :truncateContent="''",
          :link='item.slug',
          linkLabel="Read More",
          category='articles',
          :date='item.date'
        )
        .load-more-container.pt-4
          EcreativMoleculesInteractiveLoadMore.mb-0(
            v-if="!articlesStore.hideLoadMore",
            :isLoading="articlesStore.isLoading"
          )
    template(#tab-books)
      .books-grid
        EcreativMoleculesCardsCard3(
          image="/images/books/The-Advent-of-the-Promised.png"
          link="https://files.alislam.cloud/pdf/The-Advent-of-The-Promised-Messiah.pdf"
          title="The Advent of the Promised Messiah"
            subTitle="Hazrat Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/True-Justice-and-Peace.png"
          link="https://files.alislam.cloud/pdf/True-Justice-and-Peace.pdf"
          title="True Justice and Peace"
          subTitle="Mirza Masroor Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/Islam-and-Europe.png"
          link="https://files.alislam.cloud/pdf/Islam-and-Europe.pdf"
          title="The book Islam & Europe – Peace, Identity & Integration"
            subTitle="Mirza Masroor Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/The-Truth-Unveiled.png"
          link="https://files.alislam.cloud/pdf/The-Truth-Unveiled.pdf"
          title="The Truth Unveiled"
            subTitle="Hazrat Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/Our-God.png"
          link="https://files.alislam.cloud/pdf/Our-God.pdf"
          title="Our God"
          subTitle="Mirza Bashir Ahmad, M.A."
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/The-Philosophy-of-the.png"
          link="https://files.alislam.cloud/pdf/Philosophy-of-Teachings-of-Islam.pdf"
          title="The Philosophy of the Teaching of Islam"
            subTitle="Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/Hallmarks-of-the-Saints.png"
          link="https://files.alislam.cloud/pdf/Hallmarks-of-the-Saints.pdf"
          title="Hallmarks of the Saints"
            subTitle="Hadrat Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/A-message-of-peace.png"
          link="https://files.alislam.cloud/pdf/Message-of-Peace.pdf"
          title="A Message of Peace"
          subTitle="Hadrat Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/An-Elementary-Study-of-Islam.png"
          link="https://files.alislam.cloud/pdf/Elementary-Study-of-Islam.pdf"
          title="An Elementary Study of Islam"
            subTitle="Mirza Tahir Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/World-Crisis-and-the-Pathway.png"
          link="https://files.alislam.cloud/pdf/World-Crisis-and-Pathway-to-Peace.pdf"
          title="World Crisis and the Pathway"
          subTitle="Mirza Masroor Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/A-Misconception-Removed.png"
          link="https://files.alislam.cloud/pdf/A-Misconception-Removed.pdf"
          title="A Misconception Removed"
          subTitle="Mirza Ghulam Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/Life-of-Muhammad.png"
          link="https://files.alislam.cloud/pdf/Life-of-Muhammad.pdf"
          title="Life of Muhammad"
          subTitle="Hadrat Mirza Bashiruddin Mahmud Ahmad"
        )
        EcreativMoleculesCardsCard3(
          image="/images/books/Some-Distinctive-Features.png"
          link="https://files.alislam.cloud/pdf/Some-Distinctive-Features-of-Islam.pdf"
          title="Some Distinctive Features"
          subTitle="Mirza Tahir Ahmad"
        )
    //- template(#tab-arguments)
    //-   .arguments-grid.h-100
    //-     .argument-item.bg-white.p-5.mb-5.rounded-4.h-100
    //-       EcreativArchetypesHeading.modalTitle(tag="h3") Arguments
    //-       iframe.h-100.idIframe(src='https://trueislam.co.uk/argumentsPublic/', width="100%")
    template(#sidebar)
      EcreativMoleculesSidebar2.d-md-none(
        :links="links"
        title="Our Beliefs"
        background="transparent"
      )
      EcreativMoleculesSidebar.d-none.d-md-flex(
        :links="links"
        title="Our Beliefs"
        background="transparent"
      )
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { type NavigationNode, type ArticleModel } from 'data-types-config';
import { useArticlesStore } from 'data-layer/exports';

const articlesStore = useArticlesStore();

withDefaults(
  defineProps<{
    articles: ArticleModel[];
    links?: NavigationNode[];
  }>(),
  {
    links: () => [],
  },
);

const selected = ref('Articles');

const setSelected = (tab: string) => {
  selected.value = tab;
};
</script>

<style lang="scss" scoped>
/* stylelint-disable */
.articles-grid {
  display: grid;
  gap: 1rem;
  grid-auto-rows: auto; // Automatically adjust row height
  width: 100%;

  // Mobile first approach
  grid-template-columns: 1fr; // Single column for smallest screens

  @include media-breakpoint-up(sm) {
    grid-template-columns: repeat(2, 1fr); // 2 columns for small screens
  }

  @include media-breakpoint-up(md) {
    gap: 1.25rem;
  }

  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr); // 3 columns for large screens
  }

  .load-more-container {
    grid-column: 1 / -1; // Span the button across all columns
    display: flex;
    justify-content: center; // Center the button horizontally
    margin-top: 1rem; // Add spacing from the grid items
  }
}

.books-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.arguments-grid {
  display: grid;
  gap: 1rem; // Space around the grid item
  grid-template-columns: 1fr; // Single column layout
  grid-auto-rows: auto; // Automatically adjust the row height

  .argument-item {
    grid-column: span 1; // Occupies the entire column
    width: 100%; // Ensures full width
    position: relative;
    overflow: hidden;
  }

  // Responsive adjustments (if needed)
  @media (max-width: 768px) {
    grid-template-columns: 1fr; // Same layout for smaller screens
  }
}
</style>
